import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerGroup } from 'src/app/common/CustomerGroup';
import { ApiServiceBase } from './ApiServiceBase';

@Injectable({
  providedIn: 'root'
})
export class CustomerGroupService extends ApiServiceBase {
  protected readonly path = 'customergroup';
  
  get(): Observable<CustomerGroup[]> {
    return this.http.get<CustomerGroup[]>(this.getUrl());
  }
}
